module.exports = __webpack_public_path__ + "static/scale-model-of-tacoma-washington-fc7c3ba0a2fe597861e5120917d02aed.png";